import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import IntegrationSwitch from 'luxFw/integrations/IntegrationSwitch';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FormHelperText from '@material-ui/core/FormHelperText';
import api from 'util/Api';

// Helper para determinar se um campo é obrigatório
const isObrigatorio = (validador, name) => {
  if (!validador || !name) return false;
  if (Array.isArray(validador)) {
    const item = validador.find(x => x && x.propriedadeValidada === name);
    return item ? (item.obrigatorio === true || item.obrigatorio === "true") : false;
  }
  const v = validador[name];
  return v ? (v.obrigatorio === true || v.obrigatorio === "true") : false;
};

const GreenRadio = withStyles({
  root: {
    color: '#05B59D',
    '&$checked': {
      color: '#05B59D',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const useStyles = makeStyles(theme => ({
  root: {

    '& .MuiInput-underline:after': {
      borderBottomColor: '#05B59D',
      borderBottomColor: '#05B59D',
      borderBottomWidth: '2px'
    },
    /*     '& .MuiInput-underline:before': {
          borderBottomColor: '#05B59D',
          borderBottomWidth: '2px'
        }, */
    '& .MuiInput-underline:hover': {
      borderBottomColor: '#05B59D',
    },
    borderRadius: '8px 8px 0px 0px',
    ////backgroundColor: '#F3F3F3',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#3A3A3D'
  },
  label: {
    paddingLeft: '5px',
    paddingTop: '2px',
    // Asterisco dos campos obrigatórios (Material-UI v4 usa a classe .MuiFormLabel-asterisk)
    '& .MuiFormLabel-asterisk': {
      color: '#f44336',
      fontWeight: 'bold',
    }
  },
  asterisk: {
    color: '#f44336',
    fontWeight: 'bold',
  },
  input: {
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      fontFamily: 'Montserrat, sans-serif',
      color: "#666666",
      fontSize: '16px'
    },
  },
  correcaoBorda: {
    '& .MuiInput-underline:after': {
      borderBottomColor: '#05B59D',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#05B59D',
      borderBottomWidth: '2px'
    },
    '& .MuiInput-underline:hover': {
      borderBottomColor: '#05B59D',
    },
  },

}));

const paddingRow = {
  paddingLeft: 0,
  paddingRight: 0
};

function TextFieldChild(props) {
  const classes = useStyles();
  var validarErro = false;
  var mensagemErro = ""

  if (props.validador && props.validador.length > 0) {
    var inconsistencia = props.validador.filter(x => x.propriedadeValidada === props.name && x.erro);
    validarErro = inconsistencia.length > 0;
    mensagemErro = inconsistencia.length > 0 ? inconsistencia[0].mensagemErro : "";
  }

  return (
    <TextField
      required={isObrigatorio(props.validador, props.name)}
      error={validarErro ? true : false}
      className={classes.root}
      id="teste"
      autoComplete='off'
      label={props.label}
      margin="normal"
      fullWidth
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
        ///shrink: true
      }}
      InputProps={{
        disableUnderline: true
      }}
      //defaultValue="Hello World"
      type={props.tipo}

      inputProps={{
        maxLength: props.numCaracteres,
        accept: props.accept,
        multiple: props.multiple,
        step: props.step
      }}

      placeholder={props.textoplaceholder}
      disabled={(props.desabilitado === "true" || props.desabilitado === true) || (props.disabled === "true" || props.disabled === true)}
      size="small"
      value={props.tipo === 'file' ? undefined : (props.valor !== undefined && props.valor !== null ? props.valor : '')}
      onChange={props.onChange}
      onBlur={props.onBlur}
      name={props.name}
      helperText={validarErro ? mensagemErro : props.textoAjuda}
      variant="filled"
      style={{ backgroundColor: '#00000000' }}
    />
  );
}

export class LuxFwFileInput extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    const initialList = Array.isArray(props.valor) ? props.valor : [];
    this.state = { filesList: initialList };
    // Map para rastrear object URLs gerados para pré-visualização de arquivos (File/Blob)
    this.objectUrls = new Map(); // key: File/Blob, value: object URL string
  }

  componentDidUpdate(prevProps) {
    if (prevProps.valor !== this.props.valor && Array.isArray(this.props.valor)) {
      this.setState({ filesList: this.props.valor });
    }
  }

  // Verifica se o item parece ser um arquivo nativo (File/Blob)
  isFileObj = (f) => {
    if (!f) return false;
    const isNativeFile = (typeof File !== 'undefined' && f instanceof File) || (typeof Blob !== 'undefined' && f instanceof Blob);
    const looksLikeFile = f && typeof f === 'object' && 'name' in f && 'size' in f && 'type' in f;
    return isNativeFile || looksLikeFile;
  }

  // Gera/obtém uma URL de pré-visualização e abre em nova aba
  handlePreview = (file) => {
    if (!file) return;
    // Se vier do backend com url/link/path, usa diretamente
    const directUrl = (file && (file.url || file.link || file.path)) || null;
    // Resolve URLs relativas contra a base do backend para evitar 404 no dev server (localhost:3000)
    const resolvePreviewUrl = (u) => {
      if (!u || typeof u !== 'string') return '';
      const trimmed = u.trim();
      // Já absoluta
      if (/^https?:\/\//i.test(trimmed)) return trimmed;
      // Tenta resolver contra a base do axios (util/Api), garantindo barra final
      try {
        const base = (api && api.defaults && api.defaults.baseURL) ? api.defaults.baseURL : '';
        if (!base) return trimmed; // sem base definida, volta original
        const baseWithSlash = base.endsWith('/') ? base : base + '/';
        const resolved = new URL(trimmed, baseWithSlash).toString();
        return resolved;
      } catch (_) {
        return trimmed;
      }
    };

    if (typeof directUrl === 'string' && directUrl.trim().length > 0) {
      const resolvedUrl = resolvePreviewUrl(directUrl);
      // Helpers para tratar respostas JSON com envelope base64
      const readBlobAsText = (blob) => new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsText(blob);
        } catch (e) { reject(e); }
      });
      const base64ToUint8 = (b64) => {
        try {
          const binaryStr = atob(b64);
          const len = binaryStr.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) bytes[i] = binaryStr.charCodeAt(i);
          return bytes;
        } catch (_) {
          return new Uint8Array([]);
        }
      };
      const inferMimeFromName = (name) => {
        const lower = (name || '').toLowerCase();
        if (lower.endsWith('.pdf')) return 'application/pdf';
        if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
        if (lower.endsWith('.png')) return 'image/png';
        if (lower.endsWith('.gif')) return 'image/gif';
        return 'application/octet-stream';
      };

      // Tenta buscar com autorização via axios (util/Api) e abrir como object URL (inline)
      try {
        api.get(resolvedUrl, { responseType: 'blob' })
          .then(async (resp) => {
            const headers = resp && resp.headers ? resp.headers : {};
            const contentType = headers['content-type'] || headers['Content-Type'] || '';
            const blob = resp && resp.data;
            if (!blob) {
              try { window.open(resolvedUrl, '_blank', 'noopener,noreferrer'); } catch (eOpen2) { }
              return;
            }
            // Se o backend retornou JSON com envelope base64, converte para Blob real
            if (typeof contentType === 'string' && contentType.indexOf('application/json') !== -1) {
              try {
                const text = await readBlobAsText(blob);
                const json = JSON.parse(text || '{}');
                const base64 = json.base64 || json.Base64 || '';
                const nome = json.nome || json.Nome || '';
                const tipo = json.contentType || json.ContentType || inferMimeFromName(nome);
                if (base64 && base64.length > 0) {
                  const bytes = base64ToUint8(base64);
                  const realBlob = new Blob([bytes], { type: tipo || 'application/octet-stream' });
                  const objUrl = URL.createObjectURL(realBlob);
                  this.objectUrls.set(realBlob, objUrl);
                  try { window.open(objUrl, '_blank', 'noopener,noreferrer'); } catch (eOpenJson) { }
                  return;
                }
                // Se não há base64, tenta abrir direto a URL resolvida
                try { window.open(resolvedUrl, '_blank', 'noopener,noreferrer'); } catch (eOpenNoB64) { }
                return;
              } catch (eJson) {
                // Falhou ao tratar como JSON, abre blob diretamente (pode exibir texto)
                const objUrl = URL.createObjectURL(blob);
                this.objectUrls.set(blob, objUrl);
                try { window.open(objUrl, '_blank', 'noopener,noreferrer'); } catch (eOpenBlob) { }
                return;
              }
            }
            // Caso normal (PDF/imagem), abre blob diretamente
            try {
              const objUrl = URL.createObjectURL(blob);
              this.objectUrls.set(blob, objUrl);
              window.open(objUrl, '_blank', 'noopener,noreferrer');
            } catch (eOpen) {
              try { window.open(resolvedUrl, '_blank', 'noopener,noreferrer'); } catch (eOpen3) { }
            }
          })
          .catch(() => {
            // Fallback em caso de erro (ex.: CORS, 401/403 sem token)
            try { window.open(resolvedUrl, '_blank', 'noopener,noreferrer'); } catch (eOpen4) { }
          });
      } catch (eAxios) {
        try { window.open(resolvedUrl, '_blank', 'noopener,noreferrer'); } catch (eOpen5) { }
      }
      return;
    }

    // Caso seja um File/Blob, cria object URL (cacheado)
    if (this.isFileObj(file)) {
      let objUrl = this.objectUrls.get(file);
      if (!objUrl) {
        try {
          objUrl = URL.createObjectURL(file);
          this.objectUrls.set(file, objUrl);
        } catch (e) {
          objUrl = null;
        }
      }
      if (objUrl) {
        try { window.open(objUrl, '_blank', 'noopener,noreferrer'); } catch (e) { }
      }
    }
  }

  componentWillUnmount() {
    // Revoga quaisquer object URLs gerados
    try {
      this.objectUrls.forEach((url) => {
        try { URL.revokeObjectURL(url); } catch (e) { }
      });
      this.objectUrls.clear();
    } catch (e) { }
  }

  handleAddFile = (e) => {
    const files = e.target && e.target.files ? e.target.files : [];
    const maxSizeMB = this.props.maxSizeMB || 2; // default 2MB
    const maxBytes = maxSizeMB * 1024 * 1024;
    const acceptStr = (this.props.accept || '').toLowerCase();
    const allowedExts = acceptStr.split(',').map(s => s.trim().replace(/^\./, '')).filter(Boolean);
    const mimeMap = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', pdf: 'application/pdf', gif: 'image/gif' };
    const allowedMimes = allowedExts.map(ext => mimeMap[ext]).filter(Boolean);

    // Seleção de um arquivo por vez (com acumulação na lista)
    let novoArquivo = null;
    if (files && files.length > 0) {
      const f = files[0];
      const fileType = (f.type || '').toLowerCase();
      const fileExt = (f.name || '').toLowerCase().split('.').pop();
      const isTypeAllowed = (fileType && allowedMimes.length > 0) ? allowedMimes.includes(fileType) : true;
      const isExtAllowed = allowedExts.length > 0 ? allowedExts.includes(fileExt) : true;

      if (!isTypeAllowed && !isExtAllowed) {
        alert(`Tipo de arquivo não permitido. Tipos aceitos: ${allowedExts.join(', ')}`);
        if (e && e.target) e.target.value = '';
        return;
      }
      if (f.size > maxBytes) {
        alert(`Arquivo excede ${maxSizeMB}MB. Selecione um arquivo menor.`);
        if (e && e.target) e.target.value = '';
        return;
      }
      novoArquivo = f;
    }

    if (!novoArquivo) return;

    const listaAtualizada = [...this.state.filesList, novoArquivo];
    this.setState({ filesList: listaAtualizada });

    if (typeof this.props.onChange === 'function') {
      // envia evento sintético compatível com onChangeValue
      const syntheticEvent = { target: { name: this.props.name, value: listaAtualizada } };
      this.props.onChange(syntheticEvent);
    }

    // limpa o input para permitir escolher o mesmo arquivo novamente se necessário
    if (e && e.target) e.target.value = '';
  }

  handleRemove = (index) => {
    const fileToRemove = this.state.filesList[index];
    // Se houver object URL gerado, revoga antes de remover
    if (fileToRemove && this.isFileObj(fileToRemove)) {
      const url = this.objectUrls.get(fileToRemove);
      if (url) {
        try { URL.revokeObjectURL(url); } catch (e) { }
        this.objectUrls.delete(fileToRemove);
      }
    }
    const listaAtualizada = this.state.filesList.filter((_, i) => i !== index);
    this.setState({ filesList: listaAtualizada });
    if (typeof this.props.onChange === 'function') {
      const syntheticEvent = { target: { name: this.props.name, value: listaAtualizada } };
      this.props.onChange(syntheticEvent);
    }
  }

  render() {
    const tamanho = this.props.tamanho !== "" && this.props.tamanho !== null && this.props.tamanho !== undefined ? this.props.tamanho : 12;
    const disabled = (this.props.desabilitado === "true" || this.props.desabilitado === true) || (this.props.disabled === "true" || this.props.disabled === true);
    const accept = this.props.accept || '';
    const isRequired = isObrigatorio(this.props.validador, this.props.name);

    return (
      <div className={`col-md-${tamanho} col-12`}>
        <FormControl fullWidth margin="normal">
          <RequiredFormLabel required={isRequired}>{this.props.label}</RequiredFormLabel>
          <div style={{ alignItems: 'center', gap: 8 }}>
            <input
              ref={this.fileInputRef}
              type="file"
              style={{ display: 'none' }}
              accept={accept}
              multiple={false}
              onChange={this.handleAddFile}
              disabled={disabled}
            />
            <Button variant="contained" className='w-50' size="medium" color="primary" onClick={() => this.fileInputRef.current && this.fileInputRef.current.click()} disabled={disabled}>
              Selecionar arquivo
            </Button>
            {this.props.textoAjuda && <FormHelperText>{this.props.textoAjuda}</FormHelperText>}
          </div>

          {this.state.filesList && this.state.filesList.length > 0 && (
            <ul className="upload-file-list" style={{ marginTop: 8, paddingLeft: 16 }}>
              {this.state.filesList.map((f, idx) => {
                const displayName = (f && (f.name || f.fileName || f.title || f.url)) || String(f);
                const hasPreview = (f && (f.url || f.link || f.path)) || this.isFileObj(f);
                return (
                  <li key={`${this.props.name}-file-${idx}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ marginRight: 8 }}>{displayName}</span>
                    <div>
                      {hasPreview && (
                        <IconButton aria-label="Visualizar" size="small" onClick={() => this.handlePreview(f)} disabled={disabled} style={{ marginRight: 4 }}>
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      )}
                      <IconButton aria-label="Remover" size="small" onClick={() => this.handleRemove(idx)} disabled={disabled}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </FormControl>
      </div>
    );
  }
}

function TextFieldChildPesquisa(props) {
  const classes = useStyles();

  return (
    <TextField
      required={isObrigatorio(props.validador, props.name)}
      className={classes.root}
      id="teste"
      autoComplete='off'
      label={props.label}
      margin="normal"
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        )
      }}
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
      }}
      size="small"
      value={props.valor}
      onChange={props.onChange}
      onBlur={props.onBlur}
      name={props.name}
      variant="filled"
      style={{ backgroundColor: '#00000000' }}
    />
  );
}

function TextFieldChildPassword(props) {
  const classes = useStyles();
  var validarErro = false;
  var mensagemErro = ""

  if (props.validador && props.validador.length > 0) {
    var inconsistencia = props.validador.filter(x => x.propriedadeValidada === props.name && x.erro);
    validarErro = inconsistencia.length > 0;
    mensagemErro = inconsistencia.length > 0 ? inconsistencia[0].mensagemErro : "";
  }

  return (
    <TextField
      required={isObrigatorio(props.validador, props.name)}
      error={validarErro ? true : false}
      className={classes.root}
      id="teste"
      label={props.label}
      autoComplete="new-password"
      margin="normal"
      fullWidth
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
        ///shrink: true
      }}
      ////variant="filled"
      //defaultValue="Hello World"
      type="password"

      InputProps={{
        disableUnderline: true
      }}

      inputProps={{
        maxLength: props.numCaracteres
      }}

      placeholder={props.textoplaceholder}
      disabled={(props.desabilitado === "true" || props.desabilitado === true) || (props.disabled === "true" || props.disabled === true)}
      size="small"
      value={props.valor}
      onChange={props.onChange}
      onBlur={props.onBlur}
      name={props.name}
      helperText={validarErro ? mensagemErro : props.textoAjuda}
      variant="filled"
      style={{ backgroundColor: '#00000000' }}
    />
  );
}

function TextFieldMaskChild(props) {
  const classes = useStyles();
  var validarErro = false;
  var mensagemErro = ""
  if (props.validador && props.validador.length > 0) {
    var inconsistencia = props.validador.filter(x => x.propriedadeValidada === props.name && x.erro);
    validarErro = inconsistencia.length > 0;
    mensagemErro = inconsistencia.length > 0 ? inconsistencia[0].mensagemErro : "";
  }

  return (
    <TextField
      required={isObrigatorio(props.validador, props.name)}
      error={validarErro ? true : false}
      className={classes.root}
      id={props.tipoMascara}
      label={props.label}
      autoComplete='off'
      margin="normal"
      fullWidth
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
        ///shrink: true
      }}
      ////variant="filled"
      //defaultValue="Hello World"

      InputProps={{
        disableUnderline: true
      }}

      inputProps={{
        maxLength: props.numCaracteres,
      }}

      type={props.tipo}
      placeholder={props.textoplaceholder}
      disabled={(props.desabilitado === "true" || props.desabilitado === true) || (props.disabled === "true" || props.disabled === true)}
      size="small"
      value={props.valor}
      onChange={props.onChange}
      onBlur={props.onBlur}
      name={props.name}
      helperText={validarErro ? mensagemErro : props.textoAjuda}
      variant="filled"
      style={{ backgroundColor: '#00000000', fontWeight: 'bold' }}
    />
  );
}

function TextAreaChild(props) {
  const classes = useStyles();

  return (
    <TextField
      required={isObrigatorio(props.validador, props.name)}
      className={classes.root}
      id="teste"
      label={props.label}
      margin="normal"
      fullWidth
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
        ///shrink: true
      }}
      ////variant="filled"
      inputProps={{
        maxLength: props.numCaracteres,
      }}
      multiline
      minRows={props.numeroLinhas}
      type={props.tipo}
      placeholder={props.textoplaceholder}
      size="small"
      value={props.valor}
      onChange={props.onChange}
      name={props.name}
      helperText={props.textoAjuda}
      variant="filled"
      style={{ backgroundColor: '#00000000' }}
      disabled={(props.desabilitado === "true" || props.desabilitado === true) || (props.disabled === "true" || props.disabled === true)}
    />
  );
}

function TextFieldComboChild(params, props) {
  const classes = useStyles();
  const { estiloGrid, ...otherParams } = params;

  var validarErro = false;
  var mensagemErro = ""

  if (params.validador && params.validador.length > 0) {
    var inconsistencia = params.validador.filter(x => x.propriedadeValidada === params.name && x.erro);
    validarErro = inconsistencia.length > 0;
    mensagemErro = inconsistencia.length > 0 ? inconsistencia[0].mensagemErro : "";
  }

  return (
    <TextField
      {...otherParams}
      required={isObrigatorio(params.validador, params.name)}
      error={validarErro ? true : false}
      className={`${!estiloGrid ? classes.root : ''} ${params.className}`}
      label={params.label}
      margin={estiloGrid ? "none" : "normal"}
      fullWidth
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
      }}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <React.Fragment>
            {params.esperar === 'true' ? <CircularProgress size={15} /> : null}
            {params.InputProps.endAdornment}
          </React.Fragment>
        ),
      }}
      // Não definimos defaultValue nem onChange aqui para não interferir no controle do Autocomplete
      placeholder={params.textoplaceholder}
      onBlur={params.onBlur}
      size="small"
      helperText={validarErro ? mensagemErro : params.textoAjuda}
      variant="filled"
      style={{ backgroundColor: '#00000000' }}
    />
  );
}

function TextFieldComboMultiploChild(params, props) {
  const classes = useStyles();

  return (
    <TextField {...params}
      required={isObrigatorio(params.validador, params.name)}
      className={classes.root}
      id="Fixo"
      label={params.label}
      margin="normal"
      fullWidth
      InputLabelProps={{
        className: classes.label,
        classes: { asterisk: classes.asterisk },
        ////shrink: true
      }}

      placeholder={params.textoplaceholder}
      defaultValue={params.valor}
      onChange={params.onChange}
      onBlur={params.onBlur}
      size="small"
      helperText={params.textoAjuda}
    />
  );
}

export class LuxFwRow extends Component {

  render() {

    const { children } = this.props;

    return (
      <div className={`col-md-12 col-12`} style={paddingRow}>
        {children}
      </div>
    );
  }

}

export class LuxFwTextBox extends Component {
  render() {
    return this.props.tamanho !== "" && this.props.tamanho !== null && this.props.tamanho !== undefined ? (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <TextFieldChild {...this.props} />
      </div>
    ) : (<TextFieldChild {...this.props} />);
  }
}

export class LuxFwTextBoxPesquisa extends Component {
  render() {
    return (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <TextFieldChildPesquisa {...this.props} />
      </div>
    );
  }
}

export class LuxFwPasswordTextBox extends Component {
  render() {
    return (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <TextFieldChildPassword {...this.props} />
      </div>
    );
  }
}

export class LuxFwMaskTextBox extends Component {
  render() {


    return this.props.tamanho !== "" && this.props.tamanho !== null && this.props.tamanho !== undefined ? (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <TextFieldMaskChild {...this.props} />
      </div>
    ) : (<TextFieldMaskChild {...this.props} />);
  }
}

export class LuxFwTextArea extends Component {
  render() {
    return (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <TextAreaChild {...this.props} />
      </div>
    );
  }
}

export class LuxFwComboBoxMultiplo extends Component {

  handleChange = (object, value) => {
    var name = this.props.name;
    var listaOpcoes = this.props.lista;
    this.props.onChange(name, object, value, listaOpcoes);
  };

  handlePreencheDefault = () => {
    var valores = Array.isArray(this.props.valor) ? this.props.valor : [];
    var valoresDisponiveis = Array.isArray(this.props.lista) ? this.props.lista : [];
    var listaRetorno = [];

    for (var indice in valores) {

      let valor = valoresDisponiveis.filter(x => x.id == valores[indice]);
      listaRetorno.push(valor[0]?.title);
    }

    return listaRetorno;

  }

  render() {

    return (
      <div className={`col-md-${this.props.tamanho} col-12`}>

        <Autocomplete
          multiple
          id={this.props.name || 'tags-filled'}
          options={(Array.isArray(this.props.lista) ? this.props.lista : []).map((option) => option.title)}
          value={Array.isArray(this.props.lista) ? this.handlePreencheDefault() : []}
          openOnFocus
          disableCloseOnSelect
          freeSolo
          disabled={(this.props.desabilitado === "true" || this.props.desabilitado === true) || (this.props.disabled === "true" || this.props.disabled === true)}
          disableClearable={this.props.desabilitaLimpar}
          onChange={this.handleChange}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const tagProps = getTagProps({ index });
              if (this.props.desabilitaLimpar) {
                try {
                  delete tagProps.onDelete;
                } catch (_) { }
                tagProps.onDelete = undefined;
                tagProps.deleteIcon = null;
              }
              return (<Chip variant="outlined" label={option} {...tagProps} />);
            })
          }
          renderInput={params => (
            <TextFieldComboChild {...params} {...this.props} />
          )}
        />

      </div>
    );
  }
}

export class LuxFwComboBox extends Component {

  handleChange = (object, value) => {
    var name = this.props.name;
    this.props.onChange(name, object, value);
  };

  render() {
    const isMultiple = (this.props.multiplaescolha === "true" ? true : false) || this.props.multiple;
    const selectedOptions = isMultiple
      ? (Array.isArray(this.props.valor)
        ? this.props.lista.filter(opt => {
          const optId = (typeof opt === 'object') ? opt.id : opt;
          return this.props.valor.map(v => String(v)).includes(String(optId));
        })
        : [])
      : (this.props.lista.find(opt => {
        const optId = (typeof opt === 'object') ? opt.id : opt;
        return String(this.props.valor) === String(optId);
      }) || null);

    return !this.props.estiloGrid ? (
      <div className={`col-md-${this.props.tamanho} col-12 ${this.props.className}`}>
        <Autocomplete
          id={this.props.name}
          noOptionsText={this.props.mensagemListaVazia === '' ? 'Nenhum registro' : this.props.mensagemListaVazia}
          disableClearable={this.props.desabilitaLimpar}
          key={`${this.props.name}-${isMultiple ? (Array.isArray(this.props.valor) ? this.props.valor.join(',') : '') : this.props.valor}`}
          options={this.props.lista}
          getOptionLabel={option => {
            if (option == null) return '';
            if (typeof option === 'string' || typeof option === 'number') return String(option);
            const t = option.title;
            return t == null ? '' : String(t);
          }}
          value={selectedOptions}
          multiple={isMultiple}
          size="small"
          disabled={(this.props.desabilitado === "true" || this.props.desabilitado === true) || (this.props.disabled === "true" || this.props.disabled === true)}
          onChange={this.handleChange}
          onBlur={this.props.onBlur}
          renderInput={params => {
            // Filtrar props estiloGrid e desabilitado para não repassar ao TextField (que espalha no DOM)
            const { estiloGrid, desabilitado, ...restProps } = this.props;
            return <TextFieldComboChild {...params} {...restProps} estiloGrid={estiloGrid} />
          }}

          renderOption={(option, { inputValue }) => {
            const title = option && option.title ? String(option.title) : '';
            const matches = match(title, inputValue);
            const parts = parse(title, matches);

            return (
              <div className={this.props.className}>
                {parts.map((part, index) => (
                  <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                    {part.text}
                  </span>
                ))}
              </div>
            );
          }}
        />

      </div>) : (
      <Autocomplete
        id={this.props.name}
        noOptionsText={this.props.mensagemListaVazia === '' ? 'Nenhum registro' : this.props.mensagemListaVazia}
        disableClearable={this.props.desabilitaLimpar}
        key={`${this.props.name}-${isMultiple ? (Array.isArray(this.props.valor) ? this.props.valor.join(',') : '') : this.props.valor}`}
        options={this.props.lista}
        getOptionLabel={option => {
          if (option == null) return '';
          if (typeof option === 'string' || typeof option === 'number') return String(option);
          const t = option.title;
          return t == null ? '' : String(t);
        }}
        fullWidth
        value={selectedOptions}
        multiple={isMultiple}
        size="small"
        disabled={this.props.desabilitado === "true" ? true : false}
        onChange={this.handleChange}
        onBlur={this.props.onBlur}
        renderInput={params => {
          // Filtrar props estiloGrid e desabilitado para não repassar ao TextField (que espalha no DOM)
          const { estiloGrid, desabilitado, ...restProps } = this.props;
          return <TextFieldComboChild {...params} {...restProps} estiloGrid={estiloGrid} />
        }}

        renderOption={(option, { inputValue }) => {
          const matches = match(option.title, inputValue);
          const parts = parse(option.title, matches);

          return (
            <div className={this.props.className}>
              {parts.map((part, index) => (
                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                  {part.text}
                </span>
              ))}
            </div>
          );
        }}
      />
    );
  }
}

export class LuxFwSwitchCheck extends Component {
  render() {
    return (
      this.props.tamanho ?
        <div style={this.props.removePadding && { paddingLeft: 0 }} className={`col-md-${this.props.tamanho} col-12`}>
          <IntegrationSwitch disabled={this.props.disabled} estilo={this.props.estilo} semEstilizacao={this.props.semEstilizacao} posicaoLabel={this.props.posicaoLabel} name={this.props.name} valor={this.props.valor} labelSwitch={this.props.label} onChange={this.props.onChange} />
        </div>

        :

        <IntegrationSwitch disabled={this.props.disabled} estilo={this.props.estilo} semEstilizacao={this.props.semEstilizacao} posicaoLabel={this.props.posicaoLabel} name={this.props.name} valor={this.props.valor} labelSwitch={this.props.label} onChange={this.props.onChange} />
    );
  }
}

export class LuxFwOptionButton extends Component {
  render() {
    return (
      <FormControlLabel
        style={{ marginLeft: 0, paddingLeft: 0, fontFamily: 'Roboto', fontSize: '16px', color: '#3A3A3D' }}
        value={String(this.props.valorOpcao)}
        control={<GreenRadio
          id={this.props.name}
          inputProps={{ 'aria-label': 'perm' }}
        />}
        label={this.props.label}
        labelPlacement="end"
      />
    );
  }
}

export class LuxFwRadioGroup extends Component {
  handleChange = (e) => {
    const evt = e || {};
    const name = evt && evt.target ? evt.target.name : this.props.name;
    let value = evt && evt.target ? evt.target.value : undefined;
    if (typeof value === 'string') {
      if (value.toLowerCase() === 'true') value = true;
      else if (value.toLowerCase() === 'false') value = false;
    }
    // Propaga como evento sintético compatível com onChangeValue
    if (typeof this.props.onChange === 'function') {
      this.props.onChange({ target: { name, value } });
    }
  };
  render() {

    const { children } = this.props;
    const labelInline = this.props.labelInline === true || this.props.labelInline === "true";
    const noWrap = this.props.noWrap === true || this.props.noWrap === "true";
    const isHorizontal = this.props.orientacao === "horizontal";
    // Quando labelInline estiver ativo e a orientação for horizontal,
    // garantimos que os radios não quebrem linha por padrão.
    const shouldNoWrap = noWrap || (labelInline && isHorizontal);
    const justifyBetween = (this.props.justifyBetween === true || this.props.justifyBetween === "true") || (this.props.labelInlineJustifyBetween === true || this.props.labelInlineJustifyBetween === "true");
    const required = isObrigatorio(this.props.validador, this.props.name);

    return (
      <div className={`col-md-${this.props.tamanho} col-12`} >

        {labelInline ? (
          <FormControl component="fieldset" style={{ height: '100%', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'nowrap', height: '100%', width: '100%', justifyContent: justifyBetween ? 'space-between' : 'flex-start' }}>
              <RequiredFormLabel required={required} style={{ fontFamily: 'Roboto', fontSize: '16px', marginRight: '8px' }} component="legend">{this.props.label}</RequiredFormLabel>

              {isHorizontal ? (
                <RadioGroup id={this.props.name} row name={this.props.name} value={String(this.props.valor)} onChange={this.handleChange} defaultValue={this.props.valorPadrao} style={{ flexWrap: shouldNoWrap ? 'nowrap' : 'wrap', columnGap: '12px', alignItems: 'center' }}>
                  {children}
                </RadioGroup>
              ) : (
                <RadioGroup id={this.props.name} name={this.props.name} value={String(this.props.valor)} onChange={this.handleChange} defaultValue={this.props.valorPadrao}>
                  {children}
                </RadioGroup>
              )}
            </div>
          </FormControl>
        ) : (
          <FormControl component="fieldset">
            <RequiredFormLabel required={required} style={{ fontFamily: 'Roboto', fontSize: '16px' }} component="legend">{this.props.label}</RequiredFormLabel>
            {isHorizontal ? (
              <RadioGroup id={this.props.name} row name={this.props.name} value={this.props.valor} onChange={this.handleChange} defaultValue={this.props.valorPadrao} style={{ flexWrap: shouldNoWrap ? 'nowrap' : 'wrap', columnGap: '12px', alignItems: 'center' }}>
                {children}
              </RadioGroup>
            ) : (
              <RadioGroup id={this.props.name} name={this.props.name} value={this.props.valor} onChange={this.handleChange} defaultValue={this.props.valorPadrao}>
                {children}
              </RadioGroup>
            )}
          </FormControl>
        )}

      </div>
    );
  }
}


export class MultiComboReadOnly extends Component {
  render() {
    const {
      label,
      valores = [],
      tamanho = "12"
    } = this.props;

    return (
      <div className={`col-md-${tamanho} col-12`}>
        {label && (
          <div style={{ fontSize: 12, marginBottom: 6, color: '#666' }}>
            {label}
          </div>
        )}

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6,
            minHeight: 40,
            padding: '6px 8px',
            border: '1px solid #ddd',
            borderRadius: 6,
            background: '#f9f9f9'
          }}
        >
          {valores && valores.length > 0 ? (
            valores.map((item, index) => (
              <Chip
                key={index}
                label={item}
                size="small"
                style={{ backgroundColor: '#e0f2f1' }}
              />
            ))
          ) : (
            <span style={{ color: '#999', fontSize: 12 }}>
              Nenhum item selecionado
            </span>
          )}
        </div>
      </div>
    );
  }
}

// FormLabel estilizado para exibir o asterisco vermelho em campos obrigatórios
const RequiredFormLabel = withStyles({
  asterisk: {
    color: '#f44336',
    fontWeight: 'bold',
  },
})(FormLabel);
